import { OpUnitType } from 'dayjs'

import { AcceptedDayInput, day } from './day'

const cache: Map<string, boolean> = new Map()

export function isBetween(
    dateToCheck: AcceptedDayInput,
    start: AcceptedDayInput,
    end: AcceptedDayInput,
    unit?: OpUnitType | null,
    d?: '()' | '[]' | '[)' | '(]'
) {
    dateToCheck = day(dateToCheck)
    start = day(start)
    end = day(end)

    // Check cache
    const key = `${dateToCheck.valueOf()}_${start.valueOf()}_${end.valueOf()}_${unit}_${d}`
    const cacheValue = cache.get(key)
    if (cacheValue !== undefined) {
        return cacheValue
    }

    // Set cache
    const result = dateToCheck.isBetween(start, end, unit, d)
    cache.set(key, result)

    return result
}
